import { theme } from '../../../theme';
import SvgAlert from '../../../assets/alert.svg';
export const getErrorStyles = (error, touched) => {
    if (error && touched) {
        return {
            outline: `2px solid ${theme.colors.NE100}`,
        };
    }
    return {};
};
export const getErrorIconStyles = (error, touched) => {
    if (error && touched) {
        return {
            content: `url("${SvgAlert}")`,
            position: 'absolute',
            display: 'block',
            width: '16px',
            height: '16px',
            right: '40px',
            top: '15px',
        };
    }
    return {};
};
//# sourceMappingURL=styles.js.map